/* unplugin-vue-components disabled */import { render } from "./detectionInfo.vue?vue&type=template&id=3b337dbe&scoped=true"
import script from "./detectionInfo.vue?vue&type=script&lang=js"
export * from "./detectionInfo.vue?vue&type=script&lang=js"

import "./detectionInfo.vue?vue&type=style&index=0&id=3b337dbe&scoped=true&lang=css"

import exportComponent from "E:\\电梯项目文档\\lcFrontEnd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b337dbe"]])

export default __exports__